import { jsx as _jsx } from "react/jsx-runtime";
import { useModalLayout } from '#pplx/frontend/aether/components/Modal/internal/ModalLayoutContext.js';
/**
 * Fixed footer area for modal actions. Always pinned to the bottom of the
 * modal and separated from the scrollable body.
 *
 * On desktop, renders children in a right-aligned row with standard spacing —
 * designed for action buttons authored in secondary-to-primary order. On
 * mobile (bottom sheet presentation), actions stack as a reversed column so
 * each action grows full-width and the primary action renders on top.
 *
 * Must be rendered as a direct child of `<Modal>`.
 *
 * @example
 * ```tsx
 * <Modal.Footer>
 *   <Button variant="text" onClick={onClose}>Cancel</Button>
 *   <Button onClick={handleSubmit}>Submit</Button>
 * </Modal.Footer>
 * ```
 */
export function ModalFooter({ children }) {
    const { isMobile } = useModalLayout();
    // Padding is owned by the modal panel (see `ModalContent`). The footer
    // contributes only its layout.
    if (isMobile) {
        // Bottom sheets stack actions as a column so each action grows
        // full-width. Reversed so the primary action — last in desktop
        // authoring order — renders on top, matching `ConfirmationModal`.
        return _jsx("div", { className: "flex flex-col-reverse gap-2", children: children });
    }
    return _jsx("div", { className: "flex items-center justify-end gap-2", children: children });
}
//# sourceMappingURL=ModalFooter.js.map